<div *ngIf="!loader" class="h-full flex flex-col bg-gradient-to-t from-stone-100 to-white">

  <app-header-order [redirectPage]="'product'"></app-header-order>

  <div class="px-4 pt-4 xl:px-0" *ngIf="currPos">
    <div class="w-full rounded-lg bg-center bg-no-repeat bg-cover transition-all
             h-[105px] md:h-[250px] xl:h-[300px]"
      [style.background-image]="'url(' + (currPos.banner ? (currPos.banner | prodSizeFilter: 1920) : '') + ')'">
    </div>
  </div>

  <div class="flex items-center justify-center flex-1" *ngIf="currPos">
    <div class="flex flex-row w-full lg:w-[1200px] h-full px-4 xl:px-0 gap-4">

      <div class="flex-1">

        <!-- POS card -->
        <div class="bg-white rounded-2xl shadow p-4 md:p-6 mb-4 mt-4 xl:-mt-8">
          <div class="flex gap-6">
            <div *ngIf="currPos.img" class="hidden md:block shrink-0">
              <img class="w-24 h-24 rounded-xl object-cover" [src]="currPos.img" [alt]="currPos.denomination" />
            </div>

            <div class="flex flex-col">
              <div class="mb-2">
                <span class="text-lg sm:text-2xl text-gray-800 uppercase font-bold fontPoppins">
                  {{ currPos.denomination }}
                </span>
              </div>

              <div class="flex flex-col">
                <div class="flex items-center mb-1 text-sm text-gray-800 font-semibold">
                  <i class="material-icons text-indigo-500 mr-2">location_on</i>
                  <span>{{ currPos.address | uppercase }} - {{ currPos.postal }} {{ currPos.city | uppercase }}</span>
                </div>

                <div class="flex items-center text-sm text-gray-800 font-semibold">
                  <i class="material-icons text-indigo-500 mr-2">phone</i>
                  <span *ngIf="currPos.phone">{{ currPos.phone }}</span>
                </div>
              </div>

              <div class="mt-3 flex flex-wrap items-center gap-2" *ngIf="currSM">
                <span class="text-xs px-2 py-1 rounded-full bg-indigo-50 text-indigo-700">
                  {{ currSM.name }}
                </span>
                <span class="text-xs px-2 py-1 rounded-full bg-gray-100 text-gray-700"
                  *ngIf="currSM.enable_date_hour === 1">
                  {{ tools.getStor('date_order') }} {{ tools.getStor('hour_order') }}
                </span>
              </div>
            </div>
          </div>
        </div>

        <!-- Controls -->
        <div class="bg-white rounded-2xl shadow p-4 md:p-6 mb-4">
          <div class="flex flex-col gap-3">

            <!-- Rubrics -->
            <div class="flex gap-2 overflow-x-auto no-scrollbar py-1" *ngIf="displayRubrics.length">
              <button *ngFor="let rub of displayRubrics" type="button"
                class="shrink-0 px-3 py-2 rounded-xl text-sm border border-gray-200 hover:border-gray-300"
                [class.border-indigo-400]="selectedRubricId === rub.id"
                [class.bg-indigo-50]="selectedRubricId === rub.id" (click)="selectRubric(rub.id)">
                {{ rub.name }}
              </button>
            </div>

          </div>
        </div>

        <!-- J'en suis la, il faut continuer a implementer les datas dans le panier et permettre de passer a un nouvel endorder -->
        <!-- Finded prod list -->
        <app-fulle-finded-prods-list id="searchproductrub" *ngIf="!searchProductLoader && findedProducts"
          (openProdDialEvent)="openProdDial($event, 'add')" [pointOfsale]="currPos" [merchantClient$]="merchantClient"
          [findedProducts]="findedProducts" fxLayout="column"
          [class.moremarg]="!toggleRubBar && windowWidth < 1279  "></app-fulle-finded-prods-list>

        <!-- Rub - prod list  -->
        <app-fulle-rub-prod-list [class.moremarg]="!toggleRubBar && !findedProducts && windowWidth < 1279" #rubProdCont
          (openProdDialEvent)="openProdDial($event, 'add')" [rubrics$]="rubrics$" [products$]="products$"
          [newRubricsDisplay$]="newRubricsDisplay$" [pointOfsale]="currPos" [merchantClient$]="merchantClient"
          [user_]="user_" (deconnectionEvent)="deconnection()" (moreProductsEvent)="moreProducts($event)"
          [loaderpop]="loaderpop" [count]="$count" [more_products_button]="$more_products_button"
          [limit_from]="$limit_from" [scrollingElementProd]="scrollingElementProd" fxLayout="column" fxLayoutGap="20px"
          style="min-height: 65vh;" [ngStyle.gt-md]="{'min-height': '55vh'}">
        </app-fulle-rub-prod-list>


        <!-- Pied de page -->
        <app-footer-client class="w-full"></app-footer-client>
      </div>

    </div>
  </div>
  <app-fulle-handle-sidenav class="block xl:hidden" [products$]="products$" [searchProductLoader]="searchProductLoader"
    [showSearchInput]="showSearchInput" [toggleBasket]="toggleBasketResp"
    (setShowSearchInputEvent)="setShowSearchInput($event)" (setFindedProductsEvent)="setFindedProducts($event)"
    (setSearchProductLoaderEvent)="setSearchProductLoader($event)" (openBasketEvent)="openBasket()"
    [merchantClient$]="merchantClient" (resetSearchProductEvent)="resetSearchProduct()"
    (searchProductEvent)="searchProduct($event)" [closeSearch]="closeSearch"></app-fulle-handle-sidenav>
</div>

<app-fulle-page-loader [loader]="loader" [pointOfSale]="currPos" fxFlexFill>
</app-fulle-page-loader>